// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__D0ZOA","default":"Button_default__ytuvl","light":"Button_light__jIFzj","compact":"Button_compact__bcbuI"};